import { createSlice } from "@reduxjs/toolkit";

const disabilitySnapshotSlice = createSlice({
    name: "disabilitySnapshotData",
    initialState: {
        disabilitySnapshotData: [],
        snapshotReportDetails: [],
    },
    reducers: {
        setDisabilitySnapshotData(state, action) {
            state.disabilitySnapshotData = action.payload;
        },
        setSnapshotReportDetails(state, action) {
            state.snapshotReportDetails = action.payload;
        }   
    },
});

export const { setDisabilitySnapshotData, setSnapshotReportDetails } = disabilitySnapshotSlice.actions;

export default disabilitySnapshotSlice.reducer;
